import { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Navigate, Routes } from "react-router-dom";

import { RootState, useAppDispatch } from "../redux/store";
import { useSelector } from "react-redux";
import { retrieveNotification } from "../redux/slice/notification-slice";
import LoadingComp from "../components/re-usable/loading/loading";
import EuropeRouter from "../routes/europe-2023-routes";
import EuropeHeader from "../components/header/europe-2023-header";
import EuropeLayoutStyleComponent from "./components/europe-2023-layout-style.component";
import Footer from "../components/footer/footer";
// import  "../assets/styles/europe-2023-app.min.css";
// import  "../assets/styles/europe-2023.css";

const Europe2023Layout = () => {
  const dispatch = useAppDispatch();

  const { notificationData, notificationLoading, notificationError } = useSelector((state: RootState) => state.notification);

  useEffect(() => {
    dispatch(retrieveNotification());
  }, [dispatch]);

  const notification = notificationData.map((notification) => {
    return notification.notificationMenuData.map((item) => {
      return item.rapsUpdates;
    });
  });

  return (
    <>
      <EuropeLayoutStyleComponent />
      <div>
        {/* <Cookies /> */}
        <EuropeHeader />
        {/* <SiteAlerts><b>{notification}</b></SiteAlerts> */}
        {/* <Europe2023Banner /> */}
        <Suspense fallback={<LoadingComp />}>
          <Routes>
            {EuropeRouter.map((route, index) => {
              return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
            })}
          </Routes>
        </Suspense>
        <Footer />
        {/*<Convergence2023Footer footerClass=" bg-primary text-light mt-4" />
        <SvgIcons />*/}
      </div>
    </>
  );
};

export default Europe2023Layout;
